import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useCurrency } from '../contexts/CurrencyContext';
import { CURRENCIES } from '../constants/currencies';
import { DollarSign } from 'lucide-react';

const CurrencySelector = ({ className = "" }) => {
  const { displayCurrency, updateDisplayCurrency } = useCurrency();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <DollarSign className="h-4 w-4 text-slate-400" />
      <Select value={displayCurrency} onValueChange={updateDisplayCurrency}>
        <SelectTrigger className="w-[140px] h-8 text-slate-100 bg-slate-700 border-slate-600 hover:bg-slate-600 hover:text-white">
          <SelectValue className="text-slate-100 font-medium" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          {CURRENCIES.map((currency) => (
            <SelectItem key={currency.value} value={currency.value} className="text-slate-900">
              {currency.value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CurrencySelector;
